import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseAddMutation, IAddFn, IGetPostRequest, ITrainingPerson, ITrainingPersonUpsert } from '../../interfaces'

const getAddPersonMutationRequest: IGetPostRequest = params => {
  return {
    method: 'post',
    url: `${config.baseUrl}/People`,
  }
}

const useAddTrainingPersonMutation: IUseAddMutation<ITrainingPerson, ITrainingPersonUpsert> = (params, options = {}) => {
  const request = useMemo(() => getAddPersonMutationRequest(params), [params])

  const addTraining: IAddFn<ITrainingPersonUpsert, ITrainingPerson> = useCallback(
    async data => axios({ ...request, data }).then(res => res.data),
    [request],
  )

  const response = useMutation<ITrainingPerson, Error, any>({
    mutationFn: addTraining,
    ...options,
  })

  return response
}

export default useAddTrainingPersonMutation
